import React, { useState,useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat,isFunction,findArrayObject } from '../../../../utils/utils';
import { Box,Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Collapse from '@material-ui/core/Collapse';
import JourneyTripActionDialog from '../../../components/Trip/JourneyTripActionDialog';
import TransactionDetailsSideBar from '../../../components/RightSideBar/TransactionDetailsSideBar';
import TripExpenseDetailsCard from '../../../components/Payment/TripExpenseDetailsCard';
import DeleteTripExpense from '../../../components/Trip/DeleteTripExpense';
import AddFuelExpenseDialog from '../../../components/VehicleDialogs/AddFuelExpenseDialog';
import { connect } from 'react-redux';
import { tripExpenseTypes,getVendorExpense } from '../../../../store/actions/tripActionCreator';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    //padding: "16px 24px",
    //display: 'flex',
    //alignItems: 'center',
    backgroundColor:'#fff'
  },
  icon:{
    fontSize:14,
    color:'#03c'
  },
  box:{
    width:'100%',
    display:'flex',
    alignItems:'center',
    padding: "16px 24px",
  },
  rbox:{
    width:'100%',
    display:'flex',
    alignItems:'center',
    padding: "16px 24px",
    paddingTop:2,
    paddingBottom:0
  },
  expense:{
    width:'100%',
    display:'flex',
    alignItems:'center',
    padding: "16px 24px",
    paddingTop:6,
  },
  topBox:{
    width:'100%',
    display:'flex',
    alignItems:'center',
    padding: "16px 24px",
    borderBottom:'solid 1px #e3e3e3'
  },
  tripProfit:{
    color:'#161f34',
    fontSize:20,
    fontWeight:600
  },
  addExpense:{
    padding:'4px 16px',
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    color: '#0033cc',
    fontWeight: 600,
    borderRadius: 8,
    fontSize:14,
    border: 'solid 1px #0033cc',
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  listLabel:{
    fontSize:18,
    fontWeight:600,
    color:'#0b1323',
  },
  amount:{
    color:'#03c',
    fontWeight:600,
    fontSize:18,
    marginRight:24,
  },
  listRoot:{
    width: '100%',
    fontSize:14,
    color:'#0b1323',
    paddingTop:2
  },
  elistRoot:{
    width: '100%',
    paddingLeft:24,
    paddingRight:24,
    padding:2,
    fontSize:14,
    color:'#0b1323',
  },
  cutomerItem:{
    padding:0,
    cursor:'pointer'
  },
  expenseItem:{
    cursor:'pointer',
    padding:0
  },
  hireCostItem:{
    padding:0
  },
  expIcon:{
    color:'#6d717b',
    //fontSize:14
  },
  nestedRoot:{
    backgroundColor:'#f6f6f8',
    borderRadius:8,
    padding:'16px 24px 8px 16px',
    marginTop:10
  },
  nested:{
    padding:0,
    paddingBottom:8
  },
  pBox:{
    paddingLeft:24,
    paddingBottom:24,
    paddingRight:24,
    paddingTop:26,
  },
  inBox:{
    width:'100%',
    display:'flex',
    alignItems:'center',
    borderTop: '1px dotted #6b778c',
    paddingTop:16
  },
  hireCost:{
    marginRight:24
  },
  profitNormalAmount: {
    color: '#008556',
    fontSize: 18,
    fontWeight: 600,
    marginRight:24,
  },
  profitNegativeAmount: {
    color: 'red',
    fontSize: 18,
    fontWeight: 600,
    marginRight:24,
  }
}));
const JourneyTripProfitExpenseCard = (props) => {
  const {selectedTrip,journey,dispatchGetTripExpenseTypes,dispatchGetVendorExpense,updateJourney} = props;
  const classes = useStyles();
  let history = useHistory();
  let amounts = journey && journey.amounts?journey.amounts:{};
  let [current,setCurrent] = useState([])
  const handleExpand= (index)=>{
    let clone = [...current];
    clone[index] = !clone[index];
    setCurrent(clone);
  }
  let tripDetails = selectedTrip;
  let tripId = tripDetails && tripDetails.id ? tripDetails.id:'';
  let vehicleData = journey && journey.vehicle ? journey.vehicle : {};
  let hiredTrip = journey && journey.vehicle && journey.vehicle.ownershipType && journey.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorId = hiredTrip && journey && journey.vendor && journey.vendor.id ? journey.vendor.id : 0;
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let partyBalance = tripDetails && tripDetails.balanceAmount ? tripDetails.balanceAmount : null;
  let vendorBalance = journey && journey.vendor && journey.vendor.vendorBalance ?journey.vendor.vendorBalance : null;
  let vendorSettled = hiredTrip && journey && journey.vendor && journey.vendor.isVendorSettled ? journey.vendor.isVendorSettled : false;
  let transactions = journey && journey.vendorTransactions ? journey.vendorTransactions:[];
  let charges = transactions && transactions.charges?transactions.charges:[]
  let transData = findArrayObject("transactionType", 'Vehicle_Hire_Cost', charges && charges.list?charges.list:null);
  const editFuelExpenseData = {
    vehicleId: vehicleData&& vehicleData.vehicleId ? vehicleData.vehicleId : "",
    driverId: journey && journey.driver && journey.driver.driverId?journey.driver.driverId:'',
    driverName: journey && journey.driver && journey.driver.driverName?journey.driver.driverName:'',
    tripId:tripId
  }
   //React State
   const [addOpen, setAddOpen] = useState(false);
   const [editOpen,setEditOpen] = useState(false);
   const [detailsOpen,setDetailsOpen] = useState(false);
   const [transactionData, setTransactionData] = useState({})
   const [deleteOpen, setDeleteOpen] = useState(false);
   const [fuelExpenseDialogOpen, setFuelExpenseDialogOpen] = useState(false);
   const [expenseItem, setExpenseItem] = useState(null);
   const [expenseIdValue, setExpenseIdValue] = useState("");
   let actionVisible = () => {
    if (hiredTrip) {
      return (tripStatus == 'PAYMENT_RECEIVED' && vendorSettled) ? false : true
    } else {
      return (tripStatus == 'PAYMENT_RECEIVED') ? false : true
    }
  }
  let editTripExpense = {
    action: 'edit_expense',
    label: 'Update Expense',
    tabsFormat: false
  }
  const [action,setAction] = useState({
    visible: true,
    action: 'add_expense',
    label: 'Add Expense',
    tabsFormat: false,
    eventName: 'Dweb Trip Expense Create Initiated'
  });
  const handleActionSave = (status) => {
    /*if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }*/
  }
  const handleaddTripActionClose = (status) => {
    setAddOpen(false);
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleTransactionDetailsClose = () => {
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleEditCashflowActionClose = (status) => {
    setEditOpen(status)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleOnUpdateSuccess = (status) => {
    setEditOpen(status);
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const onDeleteSuccess = () => {
    setDeleteOpen(false);
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
    setTransactionData(null)
  }
  const onDeleteCancel = () => {
    setDeleteOpen(false);
    /*setTransactionData(null)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }*/
  }
  const handleFuelExpenseClose = () => {
    setFuelExpenseDialogOpen(false);
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleActionEditExpense = (item,edit) => {

    if (item && item.id) {
      dispatchGetTripExpenseTypes(() => {
        dispatchGetVendorExpense(item.id, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            if (response.response && response.response.id) {
              setTransactionData(response.response);
              if(edit){
                if (response.response.expenseType == "Fuel_Expense") {
                  setFuelExpenseDialogOpen(true);
                  setExpenseIdValue(response.response.id);
                }else {
                  setEditOpen(true);
                }
              }else{
                setDetailsOpen(true)
              }
            }
          }
        }, () => {

        })
      }, () => {

      })
    }
    /*let expenseItem;
    if (item && item.id && tripDetails && tripDetails.tripTransactions) {
      expenseItem = findArrayObject('id', item.id, tripDetails.tripTransactions)
    }
    if(expenseItem){
      setExpenseItem(expenseItem);
      setEditTripActionOpen(true);
    }*/
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
        <Box className={classes.topBox} justifyContent={'space-between'}>
          <Typography className={classes.tripProfit}>Trip Profit</Typography>
          <Button onClick={()=>{setAddOpen(true)}} className={classes.addExpense} variant="oulined"><AddIcon className={classes.icon} /> Add Expense</Button>
        </Box>
        <Box className={classes.box} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography className={classes.listLabel}>(+) Revenue</Typography>
            <Typography className={classes.amount}>{amounts.revenue?numberFormat(Number(amounts.revenue)):numberFormat(0)}</Typography>
        </Box>
        <Box className={classes.rbox}>
        <List
          component="ul"
          aria-labelledby="nested-list-subheader"
          className={classes.listRoot}
          disablePadding
        >
          {journey&& journey.trips && journey.trips.map((custTrip,index)=>{
            return <>
              <ListItem disablePadding className={classes.cutomerItem} style={{marginBottom:current[index]?0:18}} onClick={()=>{handleExpand(index)}}>
                <ListItemText primary={custTrip && custTrip.customer && custTrip.customer.customerName?custTrip.customer.customerName:''} />
                <Typography component="span">{numberFormat(Number(custTrip.revenueAmount))}</Typography>
                {current[index] ? <ArrowDropDownIcon className={classes.expIcon} /> : <ArrowRightIcon className={classes.expIcon}/>}
              </ListItem>
              <Collapse in={current[index]} timeout="auto" unmountOnExit>
                <List component="div" className={classes.nestedRoot} disablePadding>
                  <ListItem className={classes.nested}>
                    <ListItemText primary="Freight Amount" />
                    <Typography component="span">{numberFormat(Number(custTrip && custTrip.transactions && custTrip.transactions.freight && custTrip.transactions.freight.totalAmount?custTrip.transactions.freight.totalAmount:0))}</Typography>
                  </ListItem>
                  <ListItem className={classes.nested}>
                    <ListItemText primary="Total Charges" />
                    <Typography component="span">{numberFormat(Number(custTrip && custTrip.transactions && custTrip.transactions.chargesList && custTrip.transactions.chargesList.totalAmount?custTrip.transactions.chargesList.totalAmount:0))}</Typography>
                  </ListItem>
                  <ListItem className={classes.nested}>
                    <ListItemText primary="Total Deductions" />
                    <Typography component="span">{numberFormat(Number(custTrip && custTrip.transactions && custTrip.transactions.deductions&&  custTrip.transactions.deductions.totalAmount?custTrip.transactions.deductions.totalAmount:0))}</Typography>
                  </ListItem>
                </List>
              </Collapse>
            </>
          })}
        </List>
        </Box>
        <Box className={classes.expense} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography className={classes.listLabel}>(-) Expense</Typography>
            <Typography className={classes.amount}>{amounts.expenses?numberFormat(Number(amounts.expenses)):numberFormat(0)}</Typography>
        </Box>
        <List
          component="ul"
          aria-labelledby="list-subheader"
          className={classes.elistRoot}
          disablePadding
        >
          {transData && transData.id && <ListItem disablePadding className={classes.hireCostItem}>
                <ListItemText primary={transData.displayName} />
                <Typography component="span" className={classes.hireCost}>{numberFormat(Number(transData.amount))}</Typography>
          </ListItem>}
          {journey&& journey.expenses && journey.expenses.list && journey.expenses.list.map((trans,index)=>{
            return <>
              <ListItem onClick={()=>{handleActionEditExpense(trans)}} disablePadding className={classes.expenseItem}>
                <ListItemText primary={trans.displayName} />
                <Typography component="span">{numberFormat(Number(trans.amount))}</Typography>
                <ChevronRightIcon style={{color:'#03c'}} />
              </ListItem>
            </>
          })}
          {journey&& journey.trips && journey.trips.map((expTrip,index)=>{
              return (<>{expTrip&& expTrip.expenses && expTrip.expenses.list && expTrip.expenses.list.map((trans,index)=>{
                return (trans && trans.expenseType!='Vehicle_Hire_Cost'?<>
                  <ListItem onClick={()=>{handleActionEditExpense(trans)}} disablePadding className={classes.expenseItem}>
                    <ListItemText primary={trans.displayName} />
                    <Typography component="span">{numberFormat(Number(trans.amount))}</Typography>
                    <ChevronRightIcon style={{color:'#03c'}} />
                  </ListItem>
                </>:null)
              })}</>)
          })}
        </List>
        <Box className={classes.pBox} justifyContent={'space-between'}>
            <Box className={classes.inBox} justifyContent={'space-between'}>
              <Typography className={classes.listLabel}>Profit</Typography>
              <Typography className={Number(amounts.profit) < 1 ? classes.profitNegativeAmount : classes.profitNormalAmount}>{amounts.profit?numberFormat(Number(amounts.profit)):numberFormat(0)}</Typography>
            </Box>
        </Box>
      </Paper>
      {addOpen && <JourneyTripActionDialog action={action} journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip}   open={addOpen} onClose={handleaddTripActionClose} onSave={handleActionSave} />}
      {editOpen && <JourneyTripActionDialog action={editTripExpense} journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} editData={transactionData} open={editOpen} onClose={handleEditCashflowActionClose} onUpdateSuccess={handleOnUpdateSuccess} confirmText={editTripExpense.confirmText ? editTripExpense.confirmText : null} />}
      {deleteOpen && <DeleteTripExpense deleteOpen={deleteOpen} tripId={tripId} deleteId={transactionData&&transactionData.id?transactionData.id:''} onDeleteSucees={onDeleteSuccess} onDeleteNo={onDeleteCancel} />}
      {fuelExpenseDialogOpen && <AddFuelExpenseDialog open={fuelExpenseDialogOpen} journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} fuelExpenseData={transactionData} requestData={editFuelExpenseData} edit={true} expenseId={expenseIdValue} onClose={handleFuelExpenseClose} onConfirm={handleFuelExpenseClose} fromSingleTrip={true} />}
      {detailsOpen && <TransactionDetailsSideBar
                rightSideBarOpen={detailsOpen}
                sideBarTitle={'Expense Details'}
                data={transactionData}
                cStyle={true}
                onEdit={transactionData && !transactionData.id ? null : (data) => {
                  if (transactionData && transactionData.expenseType && transactionData.expenseType == "Fuel_Expense") {
                    //setFuelExpenseDialogOpen(true);
                    //setExpenseIdValue(transactionData.id);
                    handleActionEditExpense(transactionData,true);
                  }
                  else {
                    setEditOpen(true)
                  }
                }}
                onDelete={transactionData && !transactionData.id ? null : (data) => {
                   setDeleteOpen(true)
                }}
                //sideBarSecondaryTitle={null}
                handleSubmit={event => { }}
                toggleRightSideBar={handleTransactionDetailsClose}
            >
                <TripExpenseDetailsCard
                    journey={journey}
                    updateJourney={updateJourney}
                    selectedTrip={selectedTrip}
                    data={transactionData}
                    type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                />
            </TransactionDetailsSideBar>}
    </>
  );
}
const JourneyTripProfitExpenseCardWithRouter = withRouter(JourneyTripProfitExpenseCard);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchGetVendorExpense: (expenseId, onSuccess, onFailure) =>
    dispatch(getVendorExpense(expenseId, onSuccess, onFailure)),
  dispatchGetTripExpenseTypes: (onSuccess, onFailure) => dispatch(tripExpenseTypes(onSuccess, onFailure)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyTripProfitExpenseCardWithRouter);
